import React from 'react';

const ExtractFieldsList = ({ fields, onFieldChange, onAddField, onRemoveField }) => {
  // Handle field property change
  const handleFieldChange = (index, property, value) => {
    const updatedField = { ...fields[index], [property]: value };
    onFieldChange(index, updatedField);
  };

  return (
    <div className="extract-fields-section">
      <h3>Fields to Extract</h3>
      <p className="section-description">
        Define what information your voice agent should extract during conversations.
      </p>

      {fields.map((field, index) => (
        <div key={index} className="field-item">
          <div className="field-header">
            <h4>Field {index + 1}</h4>
            {fields.length > 1 && (
              <button
                type="button"
                className="btn-remove"
                onClick={() => onRemoveField(index)}
              >
                Remove
              </button>
            )}
          </div>

          <div className="field-grid">
            <div className="form-group">
              <label htmlFor={`field-name-${index}`} className="form-label">Field Name</label>
              <input
                type="text"
                id={`field-name-${index}`}
                value={field.name}
                onChange={(e) => handleFieldChange(index, 'name', e.target.value)}
                className="form-control"
                placeholder="e.g., phone_number"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor={`field-type-${index}`} className="form-label">Field Type</label>
              <select
                id={`field-type-${index}`}
                value={field.type}
                onChange={(e) => handleFieldChange(index, 'type', e.target.value)}
                className="form-control"
              >
                <option value="text">Texto</option>
                <option value="number">Número</option>
                <option value="boolean">Sí/No (Booleano)</option>
              </select>
            </div>

            <div className="form-group checkbox-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={field.required}
                  onChange={(e) => handleFieldChange(index, 'required', e.target.checked)}
                />
                Required Field
              </label>
            </div>
          </div>
        </div>
      ))}

      <button
        type="button"
        className="btn btn-secondary add-field-btn"
        onClick={onAddField}
      >
        Add Another Field
      </button>
    </div>
  );
};

export default ExtractFieldsList;
